import useOrganisation from '../../../hooks/useOrganisation';
import { BillingProvider } from '../../../util/constants';

/**
 * BillingProviderGate component that conditionally renders children based on billing provider
 *
 * @param {Object} props - Component props
 * @param {string|string[]} props.billingProviders - Required billing provider(s) to access the content
 * @param {React.ReactNode|Function} props.children - Content to render if organization has required billing provider(s)
 * @param {React.ReactNode|Function} props.renderGate - Content to render if organization lacks required billing provider(s)
 * @returns {React.ReactElement|null}
 */
const BillingProviderGate = ({ billingProviders = [], children, renderGate = null }) => {
  const organisation = useOrganisation();

  const subscriptionService =
    organisation?.subscription?.subscriptionService || BillingProvider.CHARGEBEE;
  const isAllowed = billingProviders.includes(subscriptionService);

  if (isAllowed) {
    return typeof children === 'function'
      ? children({ isAllowed, subscriptionService: subscriptionService })
      : children;
  }

  return typeof renderGate === 'function'
    ? renderGate({ isAllowed, subscriptionService: subscriptionService }, children)
    : renderGate;
};

export default BillingProviderGate;
